import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

interface NavigationInfo {
  mainUrl: string;
  params?: any;
}

@Injectable({
  providedIn: 'root'
})
export class NavigationHistoryService {
  private history: NavigationInfo[] = [];

  constructor(private _location: Location) { }

  recordNavigation(mainUrl: string, params?: any): void {
    this.history = [...this.history, { mainUrl, params }];

    if (this.history.length > 10) {
      this.history.shift();
    }
  }

  getHistory(): NavigationInfo[] {
    return this.history;
  }

  getLastUrl(): NavigationInfo {
    return this.history[this.history.length - 2] || { mainUrl: '/' };
  }

  back() {
    this._location.back();
  }
}
